// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-factor-auth-dialog__form{padding:20px 0}", "",{"version":3,"sources":["webpack://./src/components/two-factor-auth-dialog/two-factor-auth-dialog.scss"],"names":[],"mappings":"AACE,8BACE,cAAA","sourcesContent":[".two-factor-auth-dialog {\n  &__form {\n    padding: 20px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
